import { Component, inject, Input } from '@angular/core';
import { HelpStore } from '../../../stores/help/help.state';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-help-button',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.scss',
})
export class HelpButtonComponent {
  @Input() key!: string;
  private readonly store = inject(HelpStore);

  /**
   * Opens the help system using the provided key.
   *
   * @param {string} key - The unique identifier for the help content to be displayed.
   * @return {void} No return value.
   */
  openHelp(key: string): void {
    this.store.setActiveHelpKey(key);
  }
}
